"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/components/Link/Link.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
import { useSite } from "@/contexts/site/site.context";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
export function PaywallCreateTrial() {
  const $ = _c(16);
  const {
    urls
  } = useAuthentication();
  const {
    relative: currentUrl
  } = useCurrentUrl();
  const {
    name: siteName,
    subscription: t0
  } = useSite();
  const {
    trialDays
  } = t0;
  const {
    trial
  } = usePaywall();
  let t1;
  if ($[0] !== currentUrl || $[1] !== urls) {
    t1 = urls?.createTrial(currentUrl) ?? null;
    $[0] = currentUrl;
    $[1] = urls;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const trialUrl = t1;
  const isTrialExpired = trial?.isUserTrialExpired ?? false;
  if (trialUrl === null || trial === null || isTrialExpired) {
    return null;
  }
  const t2 = `Prøv ${siteName} i ${trialDays} dage - og få adgang til alt indhold.`;
  const t3 = `Testen Sie ${siteName} ${trialDays} Tage lang - und erhalten Sie Zugang zu allen Inhalten.`;
  const t4 = `Try ${siteName} for ${trialDays} days - and get access to all content.`;
  const t5 = `Prøv ${siteName} i ${trialDays} dager - og få tilgang til alt innhold.`;
  const t6 = `Prova ${siteName} i ${trialDays} dagar - och få tillgång till allt innehåll.`;
  let t7;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = <p className="flex-auto"><Translation da={t2} de={t3} en={t4} no={t5} sv={t6} /></p>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      contentId: "create-trial",
      contentSource: "paywall",
      contentType: "cta"
    };
    t9 = <Translation da={"F\xE5 et uforpligtende pr\xF8veabonnement her."} de="Erhalten Sie hier ein unverbindliches Probeabonnement." en="Get a non-binding trial subscription here." no={"F\xE5 et uforpligtende pr\xF8veabonnement her."} sv={"F\xE5 ett icke-bindande provabonnemang h\xE4r."} />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== trialUrl) {
    t10 = <Link className="text-primary hover:text-primary-hover hover:underline" href={trialUrl} position="pw-ct-tr" testId="unauthenticated-create-trial-button" trackingModel={t8}>{t9}</Link>;
    $[11] = trialUrl;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t7) {
    t11 = <div>{t7}{t10}</div>;
    $[13] = t10;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}